export enum ReportName {
  BASIC_APPLICATION_REPORT = 'BASIC_APPLICATION_REPORT',
  COMPARATIVE_APPLICATION_REPORT = 'COMPARATIVE_APPLICATION_REPORT',
}

export enum ReportNameLabels {
  BASIC_APPLICATION_REPORT = 'Podstawowy raport wniosków',
  COMPARATIVE_APPLICATION_REPORT = 'Raport porównawczy wniosków',
}

export const ReportNameLabel: Record<ReportName, string> = {
  [ReportName.BASIC_APPLICATION_REPORT]: 'Zlecony',
  [ReportName.COMPARATIVE_APPLICATION_REPORT]: 'Generowany',
};

export type ReportNameOption = {
  label: string;
  key: ReportName;
};
